import {
    ResearchTeamMemberAccessStatusEnum,
    ResearchTeamMemberRoleEnum,
    VmAdminApprovalStatusEnum,
} from '@vivli/features/data-requests/infrastructure/enum';
import { v4 as uuid } from 'uuid';

export function useResearchTeamCreate() {
    return (projectRole: ResearchTeamMemberRoleEnum) => ({
        id: uuid(),
        userId: '',
        firstName: '',
        lastName: '',
        position: '',
        educationOrQualifications: '',
        degree: '',
        fieldOfStudy: '',
        educationInstitution: '',
        yearReceived: null,
        yearsOfSecondaryAnalysis: '',
        employerOrAffiliation: '',
        orcidId: '',
        governmentOfficialIdentificationDisclosure: '',
        projectRole,
        conflictsOfInterest: '',
        email: '',
        hasAccessToVirtualMachineResource: false,
        isStatistician: projectRole === ResearchTeamMemberRoleEnum.Statistician,
        isLeadResearcher: projectRole === ResearchTeamMemberRoleEnum.Lead,
        isAdmin: false,
        adminApprovalStatus: VmAdminApprovalStatusEnum.NotApplicable, //default
        accessToDataRequest: ResearchTeamMemberAccessStatusEnum.Pending, //default (DEV-509)
        accessToData: ResearchTeamMemberAccessStatusEnum.Pending, //default (DEV-509)
    });
}
